import React from 'react'
import { useAdminSidebarLogic } from './AdminSidebar.logic.js'
import { AdminSidebarView } from './AdminSidebar.view.jsx'

function AdminSidebar() {
  const { resourceOptions, showNotifications, showTranslations } =
    useAdminSidebarLogic()

  return (
    <AdminSidebarView
      resourceOptions={resourceOptions}
      showNotifications={showNotifications}
      showTranslations={showTranslations}
    />
  )
}

export { AdminSidebar }
